import React from 'react'
import styled from 'styled-components'
import { media } from 'styles/media'

import * as spacing from 'styles/spacing'

const Container = styled.div`
  text-align: left;
  font-size: ${spacing.small};
  width: 100%;
  ${media.medium`width: 835px;`};
`

const Disclaimer = () => (
  <Container>
    <p>
      *Offer available to new MYVUSE Rewards members upon creation of a Vuse account. Includes a one-time 500 points for
      joining MYVUSE Rewards, 200 points for opting in to marketing emails, and a 500-point First Pack Code Bonus. Limit
      of one offer per customer. Members will also earn 200 points for each eligible Vuse pack code entered. Subject to
      the MYVUSE Rewards Terms and Conditions. Offer may be changed or withdrawn at any time without prior notice.
    </p>
    <p>**Points awarded vary based on MYVUSE Rewards tier status.</p>
    <p>
      ***MYVUSE Rewards codes are included on select products. Due to inventory flowthrough, not all products in market
      will have pack codes immediately. For a complete list of eligible products, please refer to the FAQ section on our
      website.{' '}
    </p>
  </Container>
)

export default Disclaimer
